export default __webpack_public_path__ + "static/media/_DSC0757.6aeaf30d.JPG";